module.exports = __webpack_public_path__ + "static/media/auto-distribution.2132d1ff.svg";